import { render, staticRenderFns } from "./chatTheme.vue?vue&type=template&id=05660d1a"
import script from "./chatTheme.vue?vue&type=script&lang=js"
export * from "./chatTheme.vue?vue&type=script&lang=js"
import style0 from "./chatTheme.vue?vue&type=style&index=0&id=05660d1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports